// extracted by mini-css-extract-plugin
module.exports = {"reference":"aB","functionName":"aC","paramsIndicator":"aD"};